import type {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorHandlerService } from '@core/error-handler/services/error-handler.service';
import { ErrorMappingRegistryService } from '@core/error-handler/services/error-mappings/error-mapping-registry.service';
import { catchError, throwError } from 'rxjs';
import { isPublicApiEndpoint } from '../constants/public-endpoints';

export const httpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const errorMappingRegistry = inject(ErrorMappingRegistryService);
  const errorHandler = inject(ErrorHandlerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Skip 401 errors - they're handled by the auth error interceptor
      // Skip public endpoints - errors must pass through untouched for anonymous pages
      if (error.status === 401 || isPublicApiEndpoint(req.url)) {
        return throwError(() => error);
      }

      const appError = errorMappingRegistry.getErrorForRequest(req.url, error.status);

      if (appError.showInInterceptor) {
        errorHandler.handleError(appError);
        return throwError(() => ({ _handledByInterceptor: true, cause: error }));
      }

      return throwError(() => error);
    })
  );
};
